import React from "react";
import AddUserForm from "../../../forms/adduserform";

const AddUserMidComp=()=>{
    return(
        <AddUserForm></AddUserForm>
    )
}

export default AddUserMidComp;